module.exports = __webpack_public_path__ + "img/1.64afa18b.jpg";